import LegalPage, {
  SectionTitleTypography,
  TermTypography,
  UnorderedList,
} from "../../../common/components/LegalPage"

export default function AiUsagePage() {
  return (
    <LegalPage title="AI Usage & Transparency">
      <SectionTitleTypography>
        Our Commitment to Transparency
      </SectionTitleTypography>
      <TermTypography>
        We believe in complete transparency regarding how technology interacts
        with your data. We have integrated Artificial Intelligence (AI) into our
        platform to empower your workflows and streamline your communications.
        This page details exactly what AI services we use, how they interact
        with your data, and what safeguards are in place.
      </TermTypography>

      <SectionTitleTypography>
        Which AI Services Do We Use?
      </SectionTitleTypography>
      <TermTypography>
        We utilize industry-leading language models provided exclusively by{" "}
        <strong>OpenAI</strong>. We do not use any alternative third-party
        language models behind the scenes, ensuring that our AI interactions are
        powered by a single, secure, and heavily-vetted provider.
      </TermTypography>

      <SectionTitleTypography>How We Use AI</SectionTitleTypography>
      <TermTypography>
        We use AI strictly as a productivity assistant. Specifically, the
        technology is utilized to help you{" "}
        <strong>generate and improve your Email and SMS campaigns</strong>. Our
        AI integration serves to translate the initial prompts and instructions
        you provide into high-quality, professional outreach messaging, helping
        you save time and focus on your core business.
      </TermTypography>

      <SectionTitleTypography>
        What Data Is Shared With Our AI Provider?
      </SectionTitleTypography>
      <TermTypography>
        We operate on a strict "least-privilege" data model when it comes to AI.
        The <strong>only</strong> information that gets transmitted to OpenAI is
        the specific, user-input text (the "prompts") you provide when
        explicitly requesting the system to generate a campaign. We do{" "}
        <strong>not</strong> automatically scan, scrape, or process your wider
        databases, prospect lists, or general account information through the AI
        model.
      </TermTypography>

      <SectionTitleTypography>
        Data Privacy and Safeguards
      </SectionTitleTypography>
      <TermTypography component="div">
        Your trust is our utmost priority. We guarantee the following
        safeguards:
        <UnorderedList>
          <li>
            <strong>No Hidden Background Processing:</strong> Our AI integration
            is purely action-based. It is triggered only when you explicitly
            press a button to generate content.
          </li>
          <li>
            <strong>No Model Training on Your Data:</strong> Under OpenAI's
            enterprise API policies, the prompts and data you pass through our
            application are <strong>not</strong> used to train or improve their
            public AI models. Your proprietary data and creative ideas remain
            exclusively yours.
          </li>
          <li>
            <strong>Zero Data Misuse:</strong> Your data is used for exactly
            what you request—nothing more. We do not sell or repurpose your AI
            queries for unsolicited secondary processing.
          </li>
        </UnorderedList>
      </TermTypography>
    </LegalPage>
  )
}
